<template>
  <div class="balance" style="display: none">
    <el-dialog
            title="提现"
            :visible.sync="cashWithdrawal"
            width="400px">
      <el-form :model="form" ref="form" label-width="68px" class="demo-ruleForm">
        <el-form-item label="提现金额" prop="inputMoney">
          <el-input v-model="form.inputMoney" placeholder="请输入提现金额"></el-input>
        </el-form-item>
        <span class="tips-text">提现最低额度为{{MinimumAmount}}元，当前可提现余额{{balance}}元，</span><el-button size="small" @click="allCash">全部提现</el-button>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cashWithdrawal = false">取消</el-button>
        <el-button type="primary" @click="confirmCash">提现</el-button>
      </span>
    </el-dialog>
    <el-dialog
            title="提示"
            :visible.sync="noRecharge"
            width="500px">
      <div class="codeText">暂时没开放提现功能，微信扫下方二维码进入{{this.$store.state.siteName}}小程序进行提现</div>
      <div class="codeImg"><img :src="this.$store.state.codeAddress"></div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="noRecharge = false">确 定</el-button>
  </span>
    </el-dialog>
    <h3 class="title">账户余额</h3>
    <div class="balance-main flex align-items">
      <div class="price">￥<i>{{myMoney}}</i><i v-if="!myMoney">0.00</i> 元</div>
      <el-button type="primary" size="medium" plain @click="noRecharge = true" v-if="myMoney > 0">立即提现</el-button>
    </div>
  </div>
</template>
<script>
  import {
    withdrawal,
    addWithdrawal,
    myDarenInfo,
    getConfig
  } from '@/config/api.js'
  export default {
    name: 'EnterpriseManageBalance',
    props: {
      myMoney: String
    },
    data () {
      return {
        money: '',
        cashWithdrawal: false,
        form: {
          inputMoney: null,
        },
        balance: '',
        MinimumAmount: '',
        noRecharge: false
      }
    },
    methods: {
      toRecharge () {
        let data = {
          user_type: this.$store.state.user_type,
          pc_id: this.$store.state.user_id,
          money: this.balance,
        };
        this.$post(withdrawal,data)
                .then(() => {
                  this.cashWithdrawal = true;
                })
                .catch(err => {
                  this.$message.error(err.msg);
                })
      },
      confirmCash () {
        if (this.form.inputMoney >= this.MinimumAmount) {
          let data = {
            user_type: this.$store.state.user_type,
            pc_id: this.$store.state.user_id,
            money: this.form.inputMoney,
          };
          this.$post(addWithdrawal,data)
                  .then(res => {
                    this.$message.success(res.msg);
                  })
                  .catch(err => {
                    this.$message.error(err.msg)
                  })
        } else {
          this.$message.error('最低提现金额不能低于' + this.MinimumAmount + '元')
        }
      },
      getMoney () {
        let data = {
          user_type: this.$store.state.user_type,
          user_id: this.$store.state.user_id,
        };
        this.$post(myDarenInfo,data)
                .then(res => {
                  this.balance = res.data.money;
                })
      },
      allCash () {
        this.form.inputMoney = this.balance;
      },
      getMinimumAmount () {
        let data = {
          key: 'withdrawal_limit_money'
        };
        this.$post(getConfig,data)
                .then(res => {
                  this.MinimumAmount = res.data
                })
                .catch(err => {
                  window.console.log(err)
                })
      }
    },
    created() {
      this.getMoney();
      this.getMinimumAmount();
    }
  }
</script>
<style scoped>
  .balance{margin-top:30px;}
  .balance .title{font-size:16px;font-weight: normal;margin-bottom:20px;}
  .balance .balance-main .price{font-size:14px;margin-right:20px;}
  .balance .balance-main .price i{font-size:36px;}
  .tips-text{font-size:12px;}
  .codeImg{text-align: center;width:100%;}
  .codeText{text-align: center;margin-bottom: 20px;}
  .codeImg img{width:180px;}
</style>
